/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ selected: NonNullable<unknown>, total: NonNullable<unknown> }} Agent_Builder_Abilities_Group_CountInputs */



/**
* | output |
* | --- |
* | "{selected} of {total}" |
*
* @param {Agent_Builder_Abilities_Group_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_abilities_group_count = /** @type {((inputs: Agent_Builder_Abilities_Group_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Abilities_Group_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.selected} von ${i?.total}`)
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total}`)
});